export default function pageSearch() {


    const pageSearch = document.querySelector('.js-page-search');
    const pageSearchInput = document.querySelector('.js-page-search-input');
    const pageSearchIcon = document.querySelector('.js-page-search-icon');
    const pageSearchCount = document.querySelector('.js-page-search-count');


    /* if ( pageSearch ) {
        if ( location.search ) {
            let search = location.search.split('=')[1];
            pageSearchInput.value = search;
            
        }
    } */
    


}